export const CONSULTANT_REFUNDS_TABLE_HEADERS = [
    'No',
    'Amount',
    'Status',
    'Reason',
    'Comment',
    'Created at',
    'Actions',
];